import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { APIService } from '../../api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';
import {DataService} from '../../services/data.service'



@Component({
  selector: 'app-batch-selection',
  templateUrl: './batch-selection.component.html',
  styleUrls: ['./batch-selection.component.scss']
})

export class BatchSelectionComponent implements OnInit {
  @Input() mdlRef: any;	
  @Input() mdlRef2: any;	
  @Input() isXn: Boolean = false;	
  @Input() batchTypeID: any = 1;	
  @Input() modeType: any = "";	
  @Input() batchesList: any = [];	
  @Input() itemID: any = 0;
  @Input() itemIndex: number = -1;
  @Input() xnID: any = 0;
  @Input() isFromTrnsJobs: Boolean = false;
  @Input() isFromStockReco: Boolean = false;	
 
  modalshow:boolean = false
  //#region "Parameter Declaration"
  batchList: batches[] = [];
  jarvisData: any = [];
  agencyData: any = [];
  codeChange = false;
  isEdit = false;
  minDate = new Date();


  objBatchEntry: batchEntry = {
    batchID: 0,
    batchName: '',
    batchQty: '0',
    expiryDT: "",
    createdDT: new Date(),
  }

  batchSelectionData: batchSelectData = {
    batchType : 0,
    item: '',
    itemUnit: '',
    mode: 'In'
  }
 
  isEditBatch: boolean = false;
  rcvdData: any = [];
  items: any = [];
  selItem: any = [];
  batchData: any = [];
  hasExpiry: boolean = false;
  srNo: number = 1;
  XnQty: any = 0;	
  batchTotalQty : number = 0;
  qtySKU : string = '';
  oldBatchList: any = [];	
  old: any = {	
    batchID: 0,	
    batchName: ''	
  }	
  
  
  showOldBatches: boolean = false;	
  fullBatchList: any = [];
  isCQShow: boolean = false;	
  isFromItemEnty : boolean = false;
  // isFromTrnsJobs : boolean = false;	
  isShowEdt : boolean = false;		

  //#endregion
  constructor(private apiService: APIService, private modalService: NgbModal, private commonService: CommonService,private dataSer: DataService, private loadingPnl: NgxSpinnerService) { }

  ngOnInit(): void {
    debugger
    this.isFromStockReco = false;
    this.dataSer.recoBatchData.subscribe((reco: any) => {
      let recoBatchData = reco;
      if(recoBatchData)
      {
        this.isFromStockReco =  recoBatchData.isFromStockReco;
      }
    })

    this.dataSer.byProduct.subscribe((value: any[]) => {	
      let fromMtrl = this.apiService.getCookie("selItems");
      this.batchList = [];	
      this.rcvdData = value;
      this.qtySKU = '';
      if(this.xnID == 10 && fromMtrl == "isFromPrd"){
        this.qtySKU = this.rcvdData.sku;
      }
      else if(this.xnID == 10 && fromMtrl == "isFromMtrl"){
        this.qtySKU = this.rcvdData.unit;
      }else{
        this.qtySKU = this.rcvdData.SKU;
      }

      if(this.rcvdData.isFrom && this.rcvdData.isFrom == 'isFromItemEntry')
      {
        this.isFromItemEnty = true;
      }	

      if(this.rcvdData) {	
        if (this.rcvdData.oldBatchList && this.rcvdData.oldBatchList != '' && this.rcvdData.oldBatchList != '[]') {	
            this.oldBatchList = this.rcvdData.oldBatchList;
            this.oldBatchlistSort();	
        }

        if(this.rcvdData.Batches && this.rcvdData.Batches.length > 0) {	
          if(this.xnID == 10){
            this.rcvdData.SKUPrecision = this.rcvdData.prcsn
          }
          else{
            this.rcvdData.SKUPrecision = this.rcvdData.Prcsn
          }

          if(this.batchesList.length > 0) {	
            this.batchData = this.batchesList;	
          }	
          else {	
            this.batchData = this.rcvdData.Batches;
            // this.batchData = JSON.parse(this.rcvdData.Batches);
            // if(this.rcvdData.isFrom == 'isFromItemEntry')
            // {
            //   this.batchData = this.rcvdData.Batches;//JSON.parse(this.rcvdData.Batches);
            // }	
            // else{
            //   this.batchData = this.rcvdData.Batches;	
            // }
            
          }	
          if(this.batchData != undefined && this.batchData != null && this.batchData != '[]'){
            this.batchData.forEach((a: any) => {	
              if(a.CQ)
              {
                this.isCQShow = true;
              }
              this.batchList.push({	
                BID: a.BID,	
                B: a.B,	
                Q: a.Q ? Number(a.Q).toFixed(this.rcvdData.SKUPrecision) :  Number(0).toFixed(this.rcvdData.SKUPrecision),
                E:a.E,	
                C:a.C	
              })	
            });	
          }
        }	

        if(this.rcvdData.transferQty)	
        {
          this.XnQty = this.rcvdData.transferQty ? Number(this.rcvdData.transferQty) : 0;
        }

        if(this.xnID == 8 || (this.xnID == 10 && fromMtrl == "isFromPrd"))
        {
          this.XnQty = this.rcvdData.issueQty ? this.rcvdData.issueQty : 0;
        }

        if(this.xnID == 10 && fromMtrl == "isFromMtrl")
        {
          this.XnQty = this.rcvdData.mtlQty ? this.rcvdData.mtlQty : 0;
        }
      }	
    });	
    //this.batchList = this.batchesList;	
    // if (this.batchTypeID == 2) {	
    //   this.hasExpiry = true;	
    // }
    this.batchSelectionData.batchType = this.rcvdData.BatchType;
    if (this.batchSelectionData.batchType == 2 || this.batchTypeID == 2) {	
      this.hasExpiry = true;	
    }
    this.batchSelectionData.mode = this.modeType;
  

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    if(this.batchesList.length == 0 && this.itemID != 0 && this.isXn) {	
      this.getProductDetail(this.itemID); 	
    } 
    else {	
      // this.batchList = this.batchesList;
      if(this.isXn){
        this.batchList = this.batchesList;
      }
      else{
        if(this.isFromStockReco == false){
            this.batchList = this.batchesList;
        }
      }
      if(this.batchList && this.hasExpiry)
      {
        this.newBatchlistSort(); 
      }	
      if(this.batchList && this.hasExpiry)
      {
        this.newBatchlistSort(); 
      }	
     
      // if (this.batchList.length > 0 && this.batchSelectionData.mode == "In") {	
      //   this.oldBatchList = this.batchList.filter((b: any) => (b.CQ && Number(b.CQ) == 0));	
      //   this.batchList = this.batchList.filter((bl: any) => (bl.CQ && Number(bl.CQ)> 0))	
      // }	
      	
    }	
    if(this.batchSelectionData.mode == "In") {	
      this.showOldBatches = true; 	
    }	
    if(this.batchSelectionData.mode == "Out") {	
      this.showOldBatches = false;	
    }
    if(this.isFromStockReco == true){
      this.showOldBatches = true; 
    }
  }

  //#region "Function"
  // openBatchMdl() - Open Batch entry modal 	
  openBatchMdl(content: any, id: number) {
    this.mdlRef2 = this.modalService.open(content, { windowClass: 'batchSelectionMdl', backdrop: 'static', keyboard: false });

  }
   //closeModal() - Close modal for Batches List	
   closeModal() {	
    this.objBatchEntry = {	
      batchID: 0,	
      batchName: '',	
      batchQty: '0',	
      expiryDT: "",	
      createdDT: new Date()	
    }	
    this.mdlRef.close();	
  }	
// closeEntryMdl() - Close batch entry modal	
  closeEntryMdl() {	
    this.objBatchEntry = {	
      batchID: 0,	
      batchName: '',	
      batchQty: '0',	
      expiryDT: "",	
      createdDT: new Date()	
    }	
    this.mdlRef2.close();	
  }

  // openBatchMdl() - Open Batch entry modal 	
openOldBatchesMdl(content: any, id: number) {	
  this.mdlRef2 = this.modalService.open(content, { windowClass: 'oldBatchAddMdlClass', backdrop: 'static', keyboard: false });	
}	
closeOldBatchesMdl(content: any) {	
  this.mdlRef2.close();	
  this.old.batchName = "";
}	
saveOldBatch () {	

  if(this.old.batchName == ''){	
    this.apiService.successAlert("Please select a batch.");	
    return;	
  }
  let selOldBatch = this.oldBatchList.filter((o: any) => o.B == this.old.batchName);	
	if(selOldBatch.length == 0){
    this.apiService.successAlert("Please select a valid batch.");	
    return;	
  }
  let selectedOldBatch = this.oldBatchList.filter((o: any) => o.B.toUpperCase().trim() == this.old.batchName.toUpperCase().trim());	
  if (selectedOldBatch.length == 1) {	
    this.batchList.push({	
      BID: selectedOldBatch[0].BID,	
      B: selectedOldBatch[0].B,	
      Q: selectedOldBatch[0].Q,	
      E: selectedOldBatch[0].E, //.customFormat("#DD#-#MMM#-#YY#"),	
      C: selectedOldBatch[0].C, //.customFormat("#DD#-#MMM#-#YY#")	
    });	
    this.oldBatchList = this.oldBatchList.filter((ob: any) => ob.B.toUpperCase().trim() != this.old.batchName.toUpperCase().trim());	
    this.oldBatchlistSort(); 
  }	
  this.closeOldBatchesMdl('');	
  	
}
  //addNewBatch() - Add new batches into list
  
  addNewBatch = () => {
    if(this.objBatchEntry.batchName == ''){	
      this.apiService.successAlert("Please enter batch name.");	
      return;	
    }	
    if(this.hasExpiry){	
      if(this.objBatchEntry.expiryDT == ''){	
        this.apiService.successAlert("Please enter expiry date.");	
        return;	
      }	
    }
    let flag = false;	
    //let checkdupBatch = this.fullBatchList.filter((db: any) => db.B.toUpperCase().trim() == this.objBatchEntry.batchName.toUpperCase().trim());	
    let curDupBatch = this.batchList.filter((cb: any) => cb.B.toUpperCase().trim() == this.objBatchEntry.batchName.toUpperCase().trim());	
    let oldDupBatch = this.oldBatchList.filter((ob: any) => ob.B.toUpperCase().trim() == this.objBatchEntry.batchName.toUpperCase().trim());	
    if(curDupBatch.length > 0 || oldDupBatch.length > 0) {	
      this.apiService.successAlert("Another batch with this name already exists.")	
      this.objBatchEntry.batchName = ''	
      return;	
    }	
    if(this.objBatchEntry.batchName.trim() == '' ){
      this.apiService.successAlert("Please enter batch name.")	
      return;	
    }
    	
    for (let i = 0; i < this.batchList.length; i++) {	
      if (this.objBatchEntry.batchName.toUpperCase().trim() == this.batchList[i].B.toUpperCase().trim()) {	
        flag = true	
        break	
      }	
      
    }
    let maxSr: any = 0;	
    let ids: any = [];
    if (this.batchList.length > 0) {	
      ids = this.batchList.map(object => {	
      return object.BID;
    })
    maxSr = Math.max(...ids);	
   }
    this.batchList.push({
      BID: Number(maxSr) + 1,
      B: this.objBatchEntry.batchName.trim(),//this.objBatchEntry.batchName,
      Q: this.objBatchEntry.batchQty,
      E: this.hasExpiry ? new Date(this.objBatchEntry.expiryDT).customFormat("#DD#-#MMM#-#YY#") : this.objBatchEntry.expiryDT, //.customFormat("#DD#-#MMM#-#YY#"), //this.objBatchEntry.expiryDT,
      C: new Date (this.objBatchEntry.createdDT).customFormat("#DD#-#MMM#-#YY#"), //.customFormat("#DD#-#MMM#-#YY#")
    });
   
    if(this.batchList && this.hasExpiry)
      {
        this.newBatchlistSort();
      }	
    //this.resetBatchEntryData();
    if(this.batchList.length > 0){
      if(this.isFromStockReco == true){
        let toSendData = {'itemID': this.itemID, 'batchList': this.batchList, 'oldBatchList': this.oldBatchList, 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': this.isShowEdt}
        this.dataSer.updateBathesData(toSendData)
      }
      this.closeEntryMdl();
    }
    else {	
      this.apiService.successAlert("This batch already exists.")	
      this.objBatchEntry.batchName = ''	
      return;	
    }	
     
  }

  fn_SaveBatches(){	
    if(this.batchList.length > 0)	
    {	
      this.batchTotalQty = 0;	
      for (let i = 0; i < this.batchList.length; i++) {	
        this.batchTotalQty = Number(this.batchTotalQty) + Number(this.batchList[i].Q);	
      }
      this.batchTotalQty = Number(Number(this.batchTotalQty).toFixed(this.rcvdData.SKUPrecision));
      if(this.isFromTrnsJobs == true){
        let tempBatchQtyList = this.batchList.filter((a: any) => a.Q > 0);
        if(tempBatchQtyList.length > 0){
          this.isShowEdt = true;
        }
      }
      
      if(Number(this.XnQty) != this.batchTotalQty) {
        if(this.isFromItemEnty == true)	
        {
          this.apiService.successAlert("Please make sure that the total batch quantity is the same as the total stock quantity.");	
          return;	
        }
        else{
          this.apiService.successAlert("Please make sure that the total batch quantity is the same as the total transaction quantity.");	
          return;	
        }
       
      }	
      let btchQtyCheck = this.batchList.filter((b: any) => b.CQ && this.isXn && this.batchSelectionData.mode == "Out" && Number(b.Q) > Number(b.CQ));	
      if (btchQtyCheck.length > 0) {	
        this.apiService.successAlert("Transfer quantity of batch should not exceed its total quantity for " + btchQtyCheck[0].B + ".");	
        return;	
      }

      let toSendData = {'itemID': this.itemID, 'itemIndex': this.itemIndex, 'batchList': JSON.parse(JSON.stringify(this.batchList)), 'oldBatchList': JSON.parse(JSON.stringify(this.oldBatchList)), 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': this.isShowEdt}
      this.dataSer.updateBathesData(toSendData)
      this.closeModal();
    }	
  }

  //change qty
  getTransferQty(obj: any) {
    obj.Q =  Number(obj.Q);
    if(this.isFromStockReco == true){
      this.getRecoQty();
     }
  } 
  
  // check issueQty and mtlQty when qty change
  prcisionCheck(obj: any) {
    obj.Q = this.commonService.PrecisionwiseValue(obj.Q + '', this.rcvdData.SKUPrecision);
    if(this.isFromStockReco == true){
      this.getRecoQty();
     }
  }

  prcnQty(obj:any) {
    obj.Q = Number(obj.Q).toFixed(this.rcvdData.SKUPrecision)
    if(this.isFromStockReco == true){
      this.getRecoQty();
     }
  }

  getRecoQty() {
    if(this.isFromStockReco == true){
      let toSendData = {'itemID': this.itemID, 'batchList': this.batchList, 'oldBatchList': this.oldBatchList, 'sumBatchesQty': this.batchTotalQty, 'isShowEdt': this.isShowEdt}
      this.dataSer.updateBathesData(toSendData)
    }
   
  } 
  //getProductDetail() - Get Product Details
  getProductDetail(id:any) {
    let data = [{
      productID: id
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 4,
      data: JSON.stringify(data)
    }];

    return this.apiService.getData(myParams, this.successResp.bind(this, id), this.failureResp.bind(this));
  }

  
  //successResp - success  get handler
  successResp(id: number, res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          alert(reponseData.Table[0].ErrMsg);
        }
        else {
          let productData = reponseData.Table[0];	
          this.rcvdData = productData;	
          // if(this.rcvdData.Batches || this.rcvdData.Batches != '[]' || this.rcvdData.Batches != '' ){
            if(this.rcvdData.Batches.length > 0  || this.rcvdData.Batches != '[]'){
            this.batchData = JSON.parse(this.rcvdData.Batches);
            this.fullBatchList = this.batchData;		
            this.batchList = this.batchData;	
              if( this.batchList.length > 0){
                this.batchList.forEach((a: any) => {	
                  a.CQ = Number(a.Q).toFixed(this.rcvdData.SKUPrecision); 		
                  a.Q = Number(0).toFixed(this.rcvdData.SKUPrecision);
                  if(a.CQ)
                  {
                    this.isCQShow = true;
                  }
                //  Q: this.isXn ? Number(0).toFixed(this.rcvdData.SKUPrecision) : 	Number(a.Q).toFixed(this.rcvdData.SKUPrecision),
              })
              if (this.batchList.length > 0 && this.isXn && (this.batchSelectionData.mode == "In" || this.batchSelectionData.mode == "Out")) {	
              this.oldBatchList = this.batchList.filter((b: any) => (b.CQ && Number(b.CQ) == 0));	
              this.batchList = this.batchList.filter((bl: any) => (bl.CQ && Number(bl.CQ)> 0));	
              if(this.oldBatchList.length > 0 && this.hasExpiry)
              {
                this.oldBatchlistSort();
              }
                if(this.batchList.length > 0 && this.hasExpiry)
                {
                  this.newBatchlistSort(); 
                }
              }
            }
          }
        }
      }
    }
  }

   //failureResp - failure handler
   failureResp(res: any) {
    this.loadingPnl.hide();
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  resetBatchEntryData = () =>{
    this.objBatchEntry.batchID = 0;
    this.objBatchEntry.batchName = "";
    this.objBatchEntry.batchQty = '0';
    this.objBatchEntry.expiryDT = "";
  }

  newBatchlistSort = () =>{
    this.batchList.sort((a,b) =>  new Date(a.E).getTime() - new Date(b.E).getTime())
  }
  oldBatchlistSort = () =>{
    this.batchList.sort((a,b) =>  new Date(a.E).getTime() - new Date(b.E).getTime())
  }

  //colorClass() - Get colors patti
  colorClass = (ind: number) => {
    switch(ind) {
      case 0:
        return 'orangePatti';
        break;
      case 1:
        return 'yellowPatti';
        break;
      case 2:
        return 'greenPatti';
        break;
      case 3:
        return 'tealPatti';
        break;
      case 4:
        return 'bluePatti';
        break;
      case 5:
        return 'darkBluePatti';
        break;
      case 6:
        return 'brownPatti';
        break;
      default:
        return 'orangePatti';
    }
  }

  //removeBatch() - Remove Batches from list
  removeBatch = (ind: number) => {
    if(ind < 0){
      this.apiService.successAlert("Please select a valid batch.");  // or serial number.
      return;
    }

    this.batchList.splice(ind, 1);
  }
  //#endregion

}

//#region "Interface"

//batches - Interface for Batch list
export interface batches {
  BID: number;
  B: string;
  Q: any;
  E: any;
  C: any;
}

//batchEntry - Interface for batch entry
export interface batchEntry {
  batchID: number;
  batchName: string;
  batchQty: any;
  expiryDT: any;
  createdDT: any;
}

export interface batchSelectData {
  batchType: number;
  item: string;
  itemUnit: string;
  mode: string; // In - Textbox / Out - DDL
}

//#endregion
